import { useRouter } from "@/lib/navigation";

export default function NotFound() {
  const router = useRouter();

  return (
    <div
      data-testid="NotFoundContainer"
      id="NotFoundContainer"
      className="flex min-h-screen items-center justify-center bg-[#111111]"
    >
      <div className="flex max-w-sm flex-col items-center px-6 text-center">
        <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-[#2d1e0e]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-7 w-7 text-orange-400"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>

        <h1 className="mb-3 text-2xl font-bold text-white">
          Page not found.
        </h1>

        <p className="mb-8 text-sm leading-relaxed text-gray-400">
          The URL may be broken, or the resource has moved. No data was lost.
        </p>

        <div className="mb-8 flex gap-3">
          <button
            onClick={() => router.push("/")}
            className="flex cursor-pointer items-center gap-2 rounded-md bg-orange-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-orange-600"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
            Home
          </button>

          <a
            href="mailto:helpdesk@liquiditycube.com"
            className="flex items-center gap-2 rounded-md border border-gray-600 bg-[#1e1e1e] px-4 py-2 text-sm font-medium text-white no-underline transition-colors hover:bg-[#2a2a2a]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
            Email helpdesk
          </a>
        </div>

        <p className="text-xs text-gray-600">
          Error code: 404 · Liquidity Cube
        </p>
      </div>
    </div>
  );
}
